import React from "react";
import { Dropdown, Menu, Button } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { useTranslate } from "../../hooks";

const RowAction = ({ width, icon, actions, onClick }) => {
  const { translate } = useTranslate();
  return (
    <Dropdown
      disabled={Object.keys(actions).filter((key) => actions[key]).length === 0}
      autoAdjustOverflow={false}
      overlay={
        <Menu>
          {Object.keys(actions)
            .filter((key) => actions[key])
            .map((key) => (
              <Menu.Item key={key} onClick={() => onClick(key)}>
                {actions[key]}
              </Menu.Item>
            ))}
        </Menu>
      }
      trigger={["click"]}
    >
      <Button>
        {icon && icon} {translate("system.useheader.title.action", "Action")}
        <CaretDownOutlined />
      </Button>
    </Dropdown>
  );
};

export default RowAction;
